import React, { CSSProperties } from 'react'
import { NavLink } from 'react-router-dom'
import styles from './style.module.scss'
import './style.scss'

interface Props {
    id?: string
    imgUrl : string
    route? : string
    backgroundColor? : string
}

const ImageIcon : React.SFC<Props> = (props) => {
    const StyleBG : CSSProperties = {
        backgroundImage: 'url(' + props.imgUrl + ')',
    }
    const StyleBC : CSSProperties = {
        backgroundColor: props.backgroundColor
    }
    return (
        <NavLink to={`${props.route}`} activeClassName="active" exact>
            <div id={`${props.id}`} className={styles.ImageIconContainer} style={StyleBC}>
                <div className={styles.ImageIcon} style={StyleBG}></div>
            </div>
        </NavLink>
    )
}

export default ImageIcon